import React from "react";
import { IconButton, Tooltip, Typography } from "@material-ui/core";
import { apiBatchRequest, apiPost, apiRequestNoLoadder } from "../../utils/api_service";
import camelcaseKeys from "camelcase-keys";
import moment from "moment";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import EditIcon from "@material-ui/icons/Edit";
import { ShowToast, toastType } from "../../utils/toast-service";
import DeleteIcon from "@material-ui/icons/Delete";
import { UpdateColumnWithConfiguration } from "../../utils/helper";
import { API_URL } from "../../constants/api";
import { GridTable } from "../common/Table/Table";
import ConfirmDialog from "../common/Dailogbox/confirmDailog";


export const imageCategoryMasterColumns = [
  {
    name: "Image Category",
    key: "categoryName",
    type: "Child",
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: "TextField",
      isEditField: true,
      isAddField: true,
    },
  },
  {
    name: "ModifiedBy",
    key: "modifiedBy",
    type: "Child",
    isRequired: true,
    isVisible: true,
    editConfig: {
      type: "TextField",
      isEditField: false,
      isAddField: false,
    },
  },
  {
    name: "ModifiedOn",
    key: "modifiedDate",
    type: "Child",
    isRequired: true,
    isVisible: true,
    dataFormat: "Date",
    editConfig: {
      type: "TextField",
      isEditField: false,
      isAddField: false,
    },
  },
  {
    name: "Action",
    key: "categoryId",
    renderComponent: "renderActionColumn",
  },
];

export default class ConfigureImageCategory extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
          imageCategoryMasterData: [],
          isInAddMode: false,
          reloadTable: false,
          selectedEditRowId: undefined,
          configuration: [],
          isInDeleteMode: false,
          updateMasterData: {
            categoryId: -1,
            categoryName: null,
            modifiedBy: "",
            modifiedDate: moment().format("YYYY-MM-DD"),
          },
          showWarningMessage: false,
          confirmMessage: "",
          selectedMarketId: this.props.globalMarketId,
          // Image cap settings
          imageCap: "",
          imageCapEdit: "",
          isEditingCap: false,
          isCapSaving: false,
        };
    }

    componentDidMount() {
        this.getRequiredData();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.globalMarketId !== this.state.selectedMarketId) {
            this.getRequiredData(nextProps.globalMarketId);
            this.setState({ selectedMarketId: nextProps.globalMarketId });
        }
    }

    getRequiredData = () => {
        this._asyncRequest = apiBatchRequest([
          {
            url: API_URL.Building.getImageCategoryMaster,
            key: "imageCategoryMasterData",
            params: { businessLineId: 1 },
          },
        ])
          .then((imageCategoryMasterData) => {
            this._asyncRequest = null;
            if (imageCategoryMasterData.imageCategoryMasterData.success === true) {
              this.setState({
                imageCategoryMasterData:
                  camelcaseKeys(imageCategoryMasterData.imageCategoryMasterData.data) || [],
                configuration:
                  camelcaseKeys(
                    imageCategoryMasterData.imageCategoryMasterData.configuration
                  ) || [],
                reloadTable: true,
              });
              this.forceUpdate();
            } else {
              ShowToast(
                "Something went wrong",
                toastType.ERROR,
                5000,
                500,
                "Server error"
              );
            }
          })
          .catch(() => {
            this._asyncRequest = null;
        });

        // Load image cap config
        apiRequestNoLoadder({
          url: API_URL.Building.getAppConfig,
          params: { configKey: "BuildingImageMaxCount", businessLineId: 1 },
        }).then(({ data }) => {
          const cap = data && data.ConfigValue ? data.ConfigValue : "";
          this.setState({ imageCap: cap, imageCapEdit: cap });
        });
    };

    cancelAddMode = () => {
        this.setState({
          selectedEditRowId: undefined,
          isInAddMode: false,
          updateMasterData: undefined,
        });
    };
    
    cancelEditMode = () => {
        this.setState({
            selectedEditRowId: undefined,
            isInAddMode: false,
            updateMasterData: undefined,
        });
    };
    
    updateRecord = () => {
        const newParam = this.state.updateMasterData;
        if (!this.isValidForm(newParam)) {
            return;
        }
        // this.state.isInDeleteMode ? newParam.statusId = 0 : newParam.statusId = newParam.statusId;
        apiPost({
            url: API_URL.Building.updateImageCategoryMaster,
            params: { businessLineId: 1 },
            postBody: newParam,
        }).then(({ data: response }) => {
            if (response.success === true) {
            ShowToast("Record updated successfully.", toastType.SUCCESS, 5000, 500);

            this.setState({
                updateMasterData: undefined,
                selectedEditRowId: undefined,
                reloadTable: !this.state.reloadTable,
                isInAddMode: false,
                showWarningMessage: false,
                confirmMessage: "",
            });
            this.getRequiredData();
            this.forceUpdate();
            } else {
            ShowToast(response.message, toastType.ERROR, 5000, 5000);
            }
        });
    };
    
    deleteRecord = (cellInfo) => {
        this.setState({
            showWarningMessage: true,
            confirmMessage: "Do you want to delete this record ?",
            updateMasterData: cellInfo,
        });
    };

    onClickHandle(e) {
        if (e) {
          this.setState(
            {
              isInDeleteMode: true,
              reloadTable: !this.state.reloadTable,
            },
            () => {
              this.forceUpdate();
            }
          );
          const newParam = this.state.updateMasterData;
          newParam.statusId = 0;
          apiPost({
            url: API_URL.Building.updateImageCategoryMaster,
            params: { businessLineId: 1 },
            postBody: newParam,
          }).then(({ data: response }) => {
            if (response.success === true) {
              ShowToast(
                "Record deleted successfully.",
                toastType.SUCCESS,
                5000,
                500
              );
    
              this.setState({
                updateMasterData: undefined,
                selectedEditRowId: undefined,
                reloadTable: !this.state.reloadTable,
                isInAddMode: false,
                showWarningMessage: false,
                confirmMessage: "",
              });
              this.getRequiredData();
              this.forceUpdate();
            } else {
              ShowToast(response.message, toastType.ERROR, 5000, 5000);
            }
          });
        } else {
          this.setState({
            showWarningMessage: false,
            confirmMessage: "",
          });
        }
    }
    
    isValidForm = (updateMasterData) => {
        const imageCategory = updateMasterData.categoryName;

        // Validate image category field 
        if (!imageCategory || imageCategory.toString().trim().length === 0) {
            ShowToast("Image Category is required.", toastType.ERROR, 5000, 500);
            return false;
        }

        return true;
    };
    
    saveUpdatedRecord = () => {
        const newParam = this.state.updateMasterData;
        if (!this.isValidForm(newParam)) {
          return;
        }
        apiPost({
          url: API_URL.Building.addImageCategoryMaster,
          params: { businessLineId: 1 },
          postBody: newParam,
        }).then(({ data: response }) => {
          if (response.success === true) {
            ShowToast(
              this.state.isInAddMode
                ? "Record added successfully."
                : "Record updated successfully.",
              toastType.SUCCESS,
              5000,
              500
            );
        
            this.setState({
              updateMasterData: undefined,
              selectedEditRowId: undefined,
              reloadTable: !this.state.reloadTable,
              isInAddMode: false,
              showWarningMessage: false,
              confirmMessage: "",
            });
            this.getRequiredData();
            this.forceUpdate();
          } else {
            ShowToast(response.message, toastType.ERROR, 5000, 5000);
          }
        });
    };

    renderActionColumn = (cellInfo, key, isInAddMode) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined &&
          cellInfo.categoryId === this.state.selectedEditRowId.value ? (
          <>
            <Tooltip title="Save Record">
              <IconButton
                aria-label={"refreshData"}
                size="small"
                onClick={() => { }}
              >
                <SaveIcon
                  fontSize="small"
                  size="small"
                  onClick={
                    this.state.isInAddMode
                      ? this.saveUpdatedRecord
                      : this.updateRecord
                  }
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="Cancel">
              <IconButton
                aria-label={"refreshData"}
                size="small"
                onClick={this.cancelEditMode}
              >
                <CancelIcon fontSize="small" size="small" />
              </IconButton>
            </Tooltip>
          </>
        ) : (
          <>
            <Tooltip title="Edit Record">
              <IconButton
                aria-label={"refreshData"}
                size="small"
                onClick={() => {
                  this.setState({
                    selectedEditRowId: {
                      key: "categoryId",
                      value: cellInfo.categoryId,
                    },
                    isInAddMode: false,
                    updateMasterData: cellInfo,
                  });
                }}
              >
                <EditIcon fontSize="small" size="small" />
              </IconButton>
            </Tooltip>
            {/*<Tooltip title="Edit Record">
		  <IconButton
			aria-label={'refreshData'}
			size="small"
			onClick={() => {
			  this.deleteRecord(cellInfo);
			}}
		  >
			<DeleteIcon fontSize="small" size="small" />
		  </IconButton>
		</Tooltip>*/}
          </>
        )}
      </>
    );
  };

  handleTableEditChange = (value, fieldName, row, addMode) => {
    const param = this.state.updateMasterData;
    if (fieldName === "categoryName") {
      param[fieldName] = value || [];
    }

    this.setState({ updateMasterData: param });
    this.forceUpdate();
  };

  AddNewRecord = () => {
    if (this.state.isInAddMode === true) {
      ShowToast("You can add one row at a time!", toastType.WARNING, 5000, 500);
      return false;
    }

    const rowNew = {
      categoryId: -1,
      categoryName: null,
      modifiedBy: "",
      modifiedDate: moment().format("YYYY-MM-DD"),
      statusId: 1,
    };
    this.setState({
      isInAddMode: true,
      selectedEditRowId: { key: "categoryId", value: -1 },
      updateMasterData: rowNew,
    });
  };

  render() {
    const { imageCategoryMasterData, imageCap, imageCapEdit, isEditingCap, isCapSaving } = this.state;

    return (
      <>
        {this.state.showWarningMessage && (
          <ConfirmDialog
            IsOpen={this.state.showWarningMessage}
            Message={this.state.confirmMessage}
            OnHandelClick={(isValid) => {
              this.onClickHandle(isValid);
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          ></ConfirmDialog>
        )}

        {/* Image Settings Section */}
        <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: "8px" }}>
          Image Settings
        </Typography>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "24px" }}>
          <Typography variant="body2" style={{ color: "#555" }}>Max Images Per Property:</Typography>
          {!isEditingCap ? (
            <>
              <Typography variant="body2" style={{ fontWeight: 600 }}>{imageCap || "—"}</Typography>
              <Tooltip title="Edit">
                <IconButton size="small" onClick={() => this.setState({ isEditingCap: true, imageCapEdit: imageCap })}>
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </>
          ) : (
            <>
              <input
                type="number"
                value={imageCapEdit}
                onChange={(e) => this.setState({ imageCapEdit: e.target.value })}
                onKeyDown={(e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()}
                min={1}
                max={100}
                autoFocus
                style={{
                  width: "60px",
                  fontSize: "14px",
                  padding: "2px 6px",
                  border: "1px solid #aaa",
                  borderRadius: "4px",
                  textAlign: "center",
                }}
              />
              <Tooltip title="Save">
                <IconButton
                  size="small"
                  disabled={isCapSaving}
                  onClick={() => {
                    const val = parseInt(imageCapEdit, 10);
                    if (!val || val < 1) {
                      ShowToast("Please enter a valid number.", toastType.ERROR, 3000, 500);
                      return;
                    }
                    this.setState({ isCapSaving: true });
                    apiPost({
                      url: API_URL.Building.updateAppConfig,
                      params: { configKey: "BuildingImageMaxCount", configValue: String(val), businessLineId: 1 },
                      postBody: {},
                    }).then(() => {
                      this.setState({ isCapSaving: false, isEditingCap: false, imageCap: String(val) });
                      ShowToast("Image cap updated.", toastType.SUCCESS, 3000, 500);
                    }).catch(() => {
                      this.setState({ isCapSaving: false });
                      ShowToast("Failed to update image cap.", toastType.ERROR, 3000, 500);
                    });
                  }}
                >
                  <SaveIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton size="small" onClick={() => this.setState({ isEditingCap: false, imageCapEdit: imageCap })}>
                  <CancelIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </>
          )}
        </div>

        {/* Image Category Configuration */}
        <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: "8px" }}>
          Configure Image Category
        </Typography>

        {imageCategoryMasterData && (
          <GridTable
            columns={UpdateColumnWithConfiguration(
              imageCategoryMasterColumns,
              this.state.configuration,
              []
            )}
            data={imageCategoryMasterData}
            renderActionColumn={this.renderActionColumn}
            selectedEditRowId={this.state.selectedEditRowId}
            isInAddMode={this.state.isInAddMode}
            EditSource={[]}
            handleTableEditChange={this.handleTableEditChange}
            updateData={this.state.updateMasterData}
            AddNewRecord={{
              action: this.AddNewRecord,
              title: "Add New Image Category",
              visible: true,
            }}
            reload={this.state.reloadTable}
          ></GridTable>
        )}
      </>
    );
  }

}